import ToolTypologyDetailsProvider from './ToolTypologyDetailsContext';
import ToolTypologyDetails from './ToolTypologyDetails';

let Index = () => {
    return (
        <ToolTypologyDetailsProvider>
            <ToolTypologyDetails />
        </ToolTypologyDetailsProvider>
    )
}

export default Index;